export default __webpack_public_path__ + "static/media/padel-champions-featured.c1d7b465.png";